import { JSX } from 'react'

import { IconProps } from '../../icon'

const Calendar: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 49 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M36.4286 11.2857H34.1429V10.1429C34.1429 9.83975 34.0225 9.54906 33.8081 9.33474C33.5938 9.12041 33.3031 9 33 9C32.6969 9 32.4062 9.12041 32.1919 9.33474C31.9776 9.54906 31.8571 9.83975 31.8571 10.1429V11.2857H18.1429V10.1429C18.1429 9.83975 18.0224 9.54906 17.8081 9.33474C17.5938 9.12041 17.3031 9 17 9C16.6969 9 16.4062 9.12041 16.1919 9.33474C15.9776 9.54906 15.8571 9.83975 15.8571 10.1429V11.2857H13.5714C12.359 11.2857 11.1962 11.7673 10.3389 12.6247C9.48163 13.482 9 14.6447 9 15.8571V35.2857C9 36.4981 9.48163 37.6609 10.3389 38.5182C11.1962 39.3755 12.359 39.8571 13.5714 39.8571H36.4286C37.641 39.8571 38.8038 39.3755 39.6611 38.5182C40.5184 37.6609 41 36.4981 41 35.2857V15.8571C41 14.6447 40.5184 13.482 39.6611 12.6247C38.8038 11.7673 37.641 11.2857 36.4286 11.2857ZM11.2857 15.8571C11.2857 15.2509 11.5265 14.6696 11.9552 14.2409C12.3838 13.8122 12.9652 13.5714 13.5714 13.5714H15.8571V14.7143C15.8571 15.0174 15.9776 15.3081 16.1919 15.5224C16.4062 15.7367 16.6969 15.8571 17 15.8571C17.3031 15.8571 17.5938 15.7367 17.8081 15.5224C18.0224 15.3081 18.1429 15.0174 18.1429 14.7143V13.5714H31.8571V14.7143C31.8571 15.0174 31.9776 15.3081 32.1919 15.5224C32.4062 15.7367 32.6969 15.8571 33 15.8571C33.3031 15.8571 33.5938 15.7367 33.8081 15.5224C34.0225 15.3081 34.1429 15.0174 34.1429 14.7143V13.5714H36.4286C37.0348 13.5714 37.6162 13.8122 38.0448 14.2409C38.4735 14.6696 38.7143 15.2509 38.7143 15.8571V17H11.2857V15.8571ZM38.7143 35.2857C38.7143 35.8919 38.4735 36.4733 38.0448 36.902C37.6162 37.3306 37.0348 37.5714 36.4286 37.5714H13.5714C12.9652 37.5714 12.3838 37.3306 11.9552 36.902C11.5265 36.4733 11.2857 35.8919 11.2857 35.2857V19.2857H38.7143V35.2857Z'
      fill='black'
    />
    <path
      d='M17 26.1429H33C33.3031 26.1429 33.5938 26.0225 33.8081 25.8081C34.0224 25.5938 34.1428 25.3031 34.1428 25C34.1428 24.6969 34.0224 24.4062 33.8081 24.1919C33.5938 23.9776 33.3031 23.8571 33 23.8571H17C16.6969 23.8571 16.4062 23.9776 16.1919 24.1919C15.9775 24.4062 15.8571 24.6969 15.8571 25C15.8571 25.3031 15.9775 25.5938 16.1919 25.8081C16.4062 26.0225 16.6969 26.1429 17 26.1429Z'
      fill='black'
    />
    <path
      d='M17 33H33C33.3031 33 33.5938 32.8796 33.8081 32.6653C34.0224 32.4509 34.1428 32.1603 34.1428 31.8572C34.1428 31.554 34.0224 31.2634 33.8081 31.049C33.5938 30.8347 33.3031 30.7143 33 30.7143H17C16.6969 30.7143 16.4062 30.8347 16.1919 31.049C15.9775 31.2634 15.8571 31.554 15.8571 31.8572C15.8571 32.1603 15.9775 32.4509 16.1919 32.6653C16.4062 32.8796 16.6969 33 17 33Z'
      fill='black'
    />
  </svg>
)

export default Calendar
